import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { TaskProtectedValueDetailInterface } from '../definitions/task-protected-value-detail-interface';

@Injectable()
export class TaskProtectedValueActualDetailService {
  public constructor(private client: HttpClient, private configService: ConfigService) {}

  public actualDetail(taskId: string): Observable<TaskProtectedValueDetailInterface> {
    const url = `${this.configService.config.rest.apiV2Url}/tasks/${taskId}/protected-value`;

    return this.client.get<TaskProtectedValueDetailInterface>(url).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}